var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.dialogTitle,
        visible: _vm.dialogVisible,
        width: "550px",
        "append-to-body": ""
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "formDataRef",
          attrs: {
            "label-position": "left",
            model: _vm.formData,
            rules: _vm.rules,
            "label-width": "100px"
          }
        },
        [
          _vm.userType == 0
            ? [
                _c("merchant-filter", {
                  ref: "merchantFilterRef",
                  attrs: { merchantId: _vm.userType },
                  on: { merchantSelected: _vm.handleMerchantSelected }
                })
              ]
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "名称", prop: "name" } },
            [
              _c("el-input", {
                staticStyle: { width: "240px" },
                attrs: { placeholder: "请输入名称", clearable: "" },
                model: {
                  value: _vm.formData.name,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "name", $$v)
                  },
                  expression: "formData.name"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "进货价格", prop: "purchase_price" } },
            [
              _c("el-input-number", {
                staticStyle: { width: "240px" },
                attrs: { min: 0, placeholder: "请输入进货价格", clearable: "" },
                model: {
                  value: _vm.formData.purchase_price,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "purchase_price", $$v)
                  },
                  expression: "formData.purchase_price"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "维修价格", prop: "repair_price" } },
            [
              _c("el-input-number", {
                staticStyle: { width: "240px" },
                attrs: { min: 0, placeholder: "请输入维修价格", clearable: "" },
                model: {
                  value: _vm.formData.repair_price,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "repair_price", $$v)
                  },
                  expression: "formData.repair_price"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "数量", prop: "quantity" } },
            [
              _c("el-input-number", {
                staticStyle: { width: "240px" },
                attrs: { min: 0, placeholder: "请输入数量", clearable: "" },
                model: {
                  value: _vm.formData.quantity,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "quantity", $$v)
                  },
                  expression: "formData.quantity"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "备注：", prop: "remark" } },
            [
              _c("el-input", {
                attrs: { type: "textarea", rows: 3, placeholder: "请输入备注" },
                model: {
                  value: _vm.formData.remark,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "remark", $$v)
                  },
                  expression: "formData.remark"
                }
              })
            ],
            1
          )
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { disabled: _vm.btn_disabled, type: "primary" },
              on: {
                click: function($event) {
                  return _vm.submit()
                }
              }
            },
            [_vm._v("提交")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", plain: "" },
              on: {
                click: function($event) {
                  _vm.dialogVisible = false
                }
              }
            },
            [_vm._v("关闭")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }